<template>
  <Attributes />
</template>

<script
  lang="ts"
  setup
>
  import { toRefs } from 'vue';
  import Attributes from '@/app/features/ams/attributes/AttributesView.vue';
  import { useAttributesStore } from '@/app/features/ams/attributes/attributes-store';
  import { useClientStore } from '@/app/features/ams/client/client-store';
  interface AttributePageProps {
    attributeId?: string;
    attributeName?: string;
  }
  const props = defineProps<AttributePageProps>();
  const attributesStore = useAttributesStore();
  const clientStore = useClientStore();
  const { attributeId, attributeName } = toRefs(props);
  if (attributeId?.value && attributeName?.value) {
    attributesStore.createAttributeTab(
      clientStore.selectedClient.id,
      Number(attributeId.value),
      attributeName.value,
      false,
      new Map()
    );
  }
</script>
